<template>
  <div v-html='md'></div>
</template>

<script>
import marked from "marked";

export default {
  computed:{
    md(){
      marked.setOptions({
        renderer: new marked.Renderer(),
        gfm: true,
        tables: true,
        breaks: false,
        pedantic: false,
        sanitize: false,
        smartLists: true,
        smartypants: false
      });
      return marked(this.source);}
  },
  props:['source']
}
</script>



// WEBPACK FOOTER //
// src/components/mdify.vue